import { BiChevronLeft, BiChevronRight } from "react-icons/bi";
import { useAppDispatch } from "../../store/hooks";

interface PropsPagination {
  current_page: number;
  next_page_url: string | null;
  prev_page_url?: string | null;
  method: any;
  status: string;
  search?: any;
}

const Footertable = ({
  current_page,
  next_page_url,
  prev_page_url,
  method,
  status,
  search,
}: PropsPagination) => {
  const dispatch = useAppDispatch();

  const nextPage = () => {
    if (search !== "") {
      dispatch(method({ page: current_page + 1, search: search }));
    } else {
      dispatch(method({ page: current_page + 1 }));
    }
  };

  const previousePage = () => {
    if (search !== "") {
      dispatch(method({ page: current_page - 1, search: search }));
    } else {
      dispatch(method({ page: current_page - 1 }));
    }
  };

  const goPage = (page: number) => {
    if (search !== "") {
      dispatch(method({ page: page, search: search }));
    } else {
      dispatch(method({ page: page, search: search }));
    }
  };
  if (
    status === "getEmployees_loading" ||
    status === "getRoles_pending" ||
    status === "getSkills_pending"
  ) {
    return null;
  }
  if (current_page === 1) {
    return (
      <div className="c-table__footer">
        <div className="c-table__box-pagination">
          {prev_page_url && (
            <div className="c-table__option-pagination c-table__option-pagination--disabled">
              <BiChevronLeft />
            </div>
          )}
          <div className="c-table__number-pagination--active">
            {current_page}
          </div>
          {next_page_url && (
            <>
              <div
                className="c-table__number-pagination"
                onClick={() => goPage(2)}
              >
                2
              </div>
              <div
                className="c-table__number-pagination"
                onClick={() => goPage(3)}
              >
                3
              </div>
              <div className="c-table__option-pagination" onClick={nextPage}>
                <BiChevronRight />
              </div>
            </>
          )}
        </div>
      </div>
    );
  }

  if (current_page > 1) {
    return (
      <div className="c-table__footer">
        <div className="c-table__box-pagination">
          {prev_page_url && (
            <div className="c-table__option-pagination" onClick={previousePage}>
              <BiChevronLeft />
            </div>
          )}
          <div className="c-table__number-pagination" onClick={previousePage}>
            {current_page - 1}
          </div>
          <div className="c-table__number-pagination--active">
            {current_page}
          </div>
          <div className="c-table__number-pagination" onClick={nextPage}>
            {next_page_url && current_page + 1}
          </div>
          {next_page_url && (
            <div className="c-table__option-pagination" onClick={nextPage}>
              <BiChevronRight />
            </div>
          )}
        </div>
      </div>
    );
  }
  return (
    <div className="c-table__footer">
      <div className="c-table__box-pagination">
        <div className="c-table__option-pagination">
          <BiChevronLeft />
        </div>
        <div className="c-table__number-pagination--active">1</div>
        <div className="c-table__number-pagination">2</div>
        <div className="c-table__number-pagination">3</div>
        <div className="c-table__option-pagination">
          <BiChevronRight />
        </div>
      </div>
    </div>
  );
};

export default Footertable;
